import { render, staticRenderFns } from "./flowTree.vue?vue&type=template&id=56cd3e2c&scoped=true"
import script from "./flowTree.vue?vue&type=script&lang=js"
export * from "./flowTree.vue?vue&type=script&lang=js"
import style0 from "./flowTree.vue?vue&type=style&index=0&id=56cd3e2c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56cd3e2c",
  null
  
)

export default component.exports